<template>
    <v-container>
        <v-row class="my-3 px-3" align="center">
            <v-col cols="12">
                <div class="headline-light secondary-color d-inline-block pointer radius-lg" v-ripple @click="goBack">
                    <v-icon class="mb-1 secondary-color">mdi-arrow-left</v-icon>
                    Volver atrás
                </div>
                <div class="display-heavy primary-color">
                    {{ title }} pack examenes
                </div>
            </v-col>
            <v-col cols="12" align="right" v-if="!!packId">
                <v-btn class="normal-btn" color="primary" outlined large @click="showDelete" :loading="loadingDelete">
                    Eliminar Pack
                </v-btn>
            </v-col>
            <v-col cols="12" class="white-card px-5">
                <v-row>
                    <v-col cols="12">
                        <v-row align="center">
                            <v-col cols="12" md="8">
                                <kimsa-tabs
                                    :tabs="tabs"
                                    @change="currentTab = $event"
                                    :value="currentTab"
                                />
                            </v-col>
                            <v-col cols="12" md="4" align="right">
                                <v-btn class="normal-btn" color="skyblue" text depressed @click="save"
                                       :disabled="!valid" :loading="loadingSave">
                                    <v-icon class="mr-2">mdi-content-save-outline</v-icon>
                                    Guardar Pack
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-divider class="mt-1 divider-secondary"/>
                    </v-col>
                </v-row>
                <loading-spinner v-if="loading"/>
                <v-form v-model="valid" class="my-3" v-else>
                    <v-row v-show="currentTab === 'details'">
                        <v-col cols="12" class="title-heavy">
                            Detalles del pack
                        </v-col>
                        <v-row class="pa-3">
                            <!-- FIRST COLUMN -->
                            <v-col cols="12" md="6">
                                <v-row>
                                    <v-col cols="12">
                                        <kimsa-text-field
                                            label="Nombre"
                                            :rules="allRules.name"
                                            @change="name = $event"
                                            :value="name"
                                            outlined dense
                                        />
                                    </v-col>
                                    <v-col cols="12">
                                        <kimsa-textarea-field
                                            label="Descripción"
                                            :rules="allRules.description"
                                            @change="description = $event"
                                            :value="description"
                                            outlined dense rows="5"
                                        />
                                    </v-col>
                                </v-row>
                            </v-col>
                            <!-- SECOND COLUMN -->
                            <v-col cols="12" md="6">
                                <kimsa-upload-file
                                    mime-types="image/jpeg,image/png"
                                    @change="onImgChange"
                                    @delete="onImgDelete"
                                    :preview-img="previewImg"
                                    relative-path="packs"
                                    is-image ref="img"
                                    :rules="allRules.file"
                                    details
                                />
                            </v-col>
                        </v-row>
                    </v-row>
                    <v-row v-show="currentTab === 'examsList'">
                        <v-col cols="12">
                            <exams-picker
                                :rules="allRules.exams"
                                @change="exams = $event"
                                :value="exams"
                            />
                        </v-col>
                    </v-row>
                </v-form>
            </v-col>
        </v-row>
        <kimsa-confirm
            ref="delete"
            title="Eliminar"
            content="¿Esta seguro que desea eliminar este pack?"
            :loading="loadingDelete"
            @confirm="onConfirmDelete"
            persistent alert-mode
            no-close-on-confirm
        />
    </v-container>
</template>

<script>

import {rules} from "@/utils/Rules"
import KimsaTextField from "@/components/common/inputs/KimsaTextField";
import LoadingSpinner from "@/components/common/LoadingSpinner";
import KimsaTextareaField from "@/components/common/inputs/KimsaTextareaField";
import ProfileSelector from "@/components/profiles/ProfileSelector";
import KimsaTabs from "@/components/KimsaTabs";
import KimsaUploadFile from "@/components/common/inputs/KimsaUploadFile";
import ExamsPicker from "@/components/exams/ExamsPicker";
import KimsaConfirm from "@/components/common/KimsaConfirm";
import httpService from "@/services/httpService";

export default {
    name: "CreatePack",
    components: {
        KimsaConfirm,
        ExamsPicker,
        KimsaUploadFile,
        KimsaTabs,
        ProfileSelector,
        KimsaTextareaField,
        LoadingSpinner,
        KimsaTextField
    },
    data() {
        return {
            loading: false,
            loadingSave: false,
            loadingDelete: false,
            valid: false,
            tabs: [
                {name: 'Detalles', value: 'details'},
                {name: 'Listado exámenes', value: 'examsList'},
            ],
            currentTab: 'details',
            pack: null,
            name: '',
            description: '',
            file: null,
            exams: [],
            deleteImg: false,
        }
    },
    computed: {
        packId(vm = this) {
            return vm.$route.params.packId || null
        },
        allRules() {
            return {
                name: [rules.required, rules.minLength(this.name, 3)],
                description: [rules.required],
                exams: [rules.required, rules.array],
            }
        },
        title(vm = this) {
            if (!!vm.packId) return 'Detalle de'
            return 'Crear'
        },
        previewImg(vm = this) {
            return vm.file?.img || null
        },
    },
    async mounted() {
        const vm = this
        if (!!vm.packId) await vm.loadPack()
    },
    methods: {
        async loadPack() {
            const vm = this
            vm.loading = true
            let response = await httpService.get(`packs/${vm.packId}`)
            vm.pack = response.data.pack
            // console.log('vm.pack',vm.pack)
            vm.name = vm.pack.name
            vm.description = vm.pack.description
            vm.file = vm.pack?.filepath ? {img: `${vm.baseUrl}${encodeURI(vm.pack.filepath)}`} : null
            vm.exams = vm.pack.exams.map(item => (item.id))
            vm.loading = false
        },
        showDelete() {
            const vm = this
            vm.$refs.delete.show()
        },
        async onConfirmDelete() {
            const vm = this
            vm.loadingDelete = true
            let response = await httpService.delete(`packs/${vm.packId}/delete`)
            vm.goBack()
            vm.loadingDelete = false
            vm.toast(response.data.message)
        },
        async save() {
            const vm = this
            !!vm.packId ? console.log('editing') : console.log('saving')
            vm.loadingSave = true
            let payload = new FormData()
            payload.append('laboratory_id', vm.currentEntityId)
            payload.append('name', vm.name)
            payload.append('description', vm.description)
            payload.append('exams', JSON.stringify(vm.exams))
            if (vm.file?.file) payload.append('file', vm.file.file)
            if(!!vm.packId) payload.append('delete_img', vm.deleteImg)

            let response;
            !!vm.packId ?
                response = await httpService.putFile(`packs/${vm.packId}/edit`, payload) :
                response = await httpService.postFile('packs/create', payload)

            vm.goBack()
            vm.loadingSave = false
            vm.toast(response.data.message)
        },
        onImgChange(file) {
            const vm = this
            vm.file = file
            vm.deleteImg = false
        },
        onImgDelete() {
            const vm = this
            vm.deleteImg = true
        }
    },
}
</script>

<style scoped>

</style>